import React, { Fragment } from 'react';
import styled from 'styled-components';

import { Cmd } from './Cmd';
import { Shift } from './Shift';
import { Shortcut } from './Shortcut';

const ShortcutsContainer = styled.div`
  display: flex;
  width: 100%;
  justify-content: right;

  ${Shortcut} {
    margin-right: 4px;
  }
  ${Shortcut}:last-child {
    margin-right: 0;
  }
`;

const ShortcutKey = ({ shortcutKey }: { shortcutKey: string }) => {
  if (shortcutKey === 'shift') {
    return <Shift />;
  }
  if (shortcutKey === 'mod') {
    return <Cmd />;
  }
  return <Fragment>{shortcutKey}</Fragment>;
};

export const Shortcuts = ({ keys, enabled = true }: { keys: string[]; enabled?: boolean }) => (
  <ShortcutsContainer>
    {keys.map((key) => (
      <Shortcut key={key} enabled={enabled}>
        <ShortcutKey shortcutKey={key} />
      </Shortcut>
    ))}
  </ShortcutsContainer>
);
